import { get, post } from '../request';
import { BASE } from './config';
import { AuthService } from './auth';

export const PostsApi = {
  async newPostInfo({ postId } = {}) {
    const headers = AuthService.getAuthHeaders();
    const url = `${BASE}/newPost/info`;
    const body = {
      post_id: postId,
    };
    const res = await post(url, body, { headers, withAuth: true });
    return res;
  },
  async newPostUserList({ page = 1, size = 10, isMe = false, beUserId } = {}) {
    const headers = AuthService.getAuthHeaders();
    const url = `${BASE}/newPost/user/list/no/auth`;
    const body = {
      page,
      size,
      is_me: isMe,
      be_user_id: beUserId,
    };
    const res = await post(url, body, { headers, withAuth: true });
    return res;
  },
  async activityTagVideoLatest({ tagId, page = 1, size = 10 } = {}) {
    const headers = AuthService.getAuthHeaders();
    const url = `${BASE}/newPost/activity/tag/video/latest`;
    const body = {
      tag_id: tagId,
      page,
      size,
      content_type_list: ['VIDEO']
    };
    const res = await post(url, body, { headers, withAuth: true });
    return res;
  },
  async activityTagVideoHot({ tagId, page = 1, size = 10 } = {}) {
    const headers = AuthService.getAuthHeaders();
    const url = `${BASE}/newPost/activity/tag/video/hot`;
    const body = {
      tag_id: tagId,
      page,
      size,
      content_type_list: ['VIDEO']
    };
    const res = await post(url, body, { headers, withAuth: true });
    return res;
  },
  async uploadFileToOSS({ file, folder = 'uploads', filename } = {}) {
    if (!file) {
      throw new Error('缺少文件参数');
    }
    const accessToken = AuthService.getAccessToken();
    if (!accessToken) {
      throw new Error('用户未登录，无法上传文件到OSS');
    }
    const name = filename || file.name || 'file';
    const formData = new FormData();
    formData.append('file', file, name);

    const headers = AuthService.getAuthHeaders();
    delete headers['Content-Type'];

    const uploadUrl = `${BASE}/oss/upload?folder=${encodeURIComponent(folder)}`;
    const res = await post(uploadUrl, formData, {
      headers,
      withAuth: true,
      timeout: 60000,
    });
    return res?.data ?? res ?? {};
  },
  async uploadFilesToOSS({ files, folder = 'uploads' } = {}) {
    if (!files || !files.length) {
      throw new Error('缺少文件列表');
    }
    const results = [];
    for (let i = 0; i < files.length; i++) {
      try {
        const data = await PostsApi.uploadFileToOSS({ file: files[i], folder });
        results.push({ success: true, data });
      } catch (e) {
        results.push({
          success: false,
          error: String(e),
          file_index: i,
        });
      }
    }
    return results;
  },
  async searchTags({
    keyword,
    category,
    sortBy = 'usage_count',
    sortOrder = 'DESC',
    limit = 20,
    includeUsageCount = true,
  } = {}) {
    const params = {
      keyword: keyword ?? '',
      sort_by: sortBy,
      sort_order: sortOrder,
      limit,
      include_usage_count: includeUsageCount,
    };
    if (category) {
      params.category = category;
    }
    const headers = AuthService.getAuthHeaders();
    const res = await get(`${BASE}/posts/tags/search`, {
      params,
      headers,
      withAuth: true,
    });
    return res;
  },
  async createSimilarPost({
    title,
    content,
    imageUrls,
    videoUrl,
    coverUrl,
    aiPromptSummary,
    visibility = 'PUBLIC',
    istemplate
  } = {}) {
    // 允许空标题和内容
    let contentType;
    let coverUrlFinal = coverUrl || null;
    let videoUrlField = null;
    if (videoUrl && String(videoUrl).length > 0) {
      contentType = 'VIDEO';
      videoUrlField = videoUrl;
      if (!coverUrlFinal) {
        coverUrlFinal = Array.isArray(imageUrls) && imageUrls.length > 0 ? imageUrls[0] : null;
      }
    } else if (Array.isArray(imageUrls) && imageUrls.length > 0) {
      contentType = 'IMAGE_SET';
      coverUrlFinal = coverUrlFinal || imageUrls[0];
      videoUrlField = imageUrls.length > 1 ? JSON.stringify(imageUrls.slice(1)) : null;
    } else {
      contentType = 'IMAGE';
    }
    const requestData = {
      title,
      description: content,
      content_type: contentType,
      content_ref_id: '',
      cover_url: coverUrlFinal || '',
      video_url: videoUrlField || '',
      is_template: istemplate,
      visibility,
      ai_prompt_summary: aiPromptSummary,
      // published_at: new Date().toISOString(),
    };



    const headers = AuthService.getAuthHeaders();
    const url = `${BASE}/posts/`;
    const res = await post(url, requestData, { headers, withAuth: true });
    return res;
  },
  async addTagsToPost({ postId, tagIds } = {}) {
    if (!postId || !Array.isArray(tagIds)) {
      throw new Error('缺少参数');
    }
    const headers = AuthService.getAuthHeaders();
    const url = `${BASE}/posts/${encodeURIComponent(postId)}/tags`;
    const body = { tag_ids: tagIds };
    const res = await post(url, body, { headers, withAuth: true });
    return res;
  },
};

export default PostsApi;
